import '../css/WBLogo.less';

import * as React from 'react';
import {Link} from 'react-router-dom';
import makeComp from '../util/profiler';

const WBLogo: React.FC = makeComp(
  props => {
    const onSignup = window.location.pathname === '/signup';
    return (
      <Link className="wandb-logo" to={onSignup ? '/signup' : '/'}>
        <div className="dots-column">
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot big-dot" />
          <div className="dot big-dot" />
        </div>
        <div className="dots-column">
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
          <div className="dot small-dot" />
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
        </div>
        <div className="dots-column">
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
          <div className="dot small-dot" />
          <div className="dot small-dot" />
          <div className="dot small-dot" />
          <div className="dot big-dot" />
          <div className="dot small-dot" />
        </div>
      </Link>
    );
  },
  {id: 'WBLogo'}
);

export default WBLogo;
